import React,{ useState , useEffect } from 'react'
import { Container } from 'reactstrap'
import { errorToast } from '../../../../_helper/helper' 
import AreaService from '../../../../api/areaService'
import { getCurrentWeekWithYear } from '../../../../utils/currentWeekWithYear'
import Loader1 from "../../../../CommonElements/Spinner/loader";
import SupervisorCardForArea from '../../../Screens/GlobalUser/AIModelReports/SupervisorCardForArea'

export default function Supervisors() {
    const [loading, setloading] = useState(true)
    const [AllSupervisors, setAllSupervisors] = useState([])
    const [userData, setuserData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [filters, setfilters] = useState()
    const getSupervisorDetial=async()=>{
        setloading(true)
        try {
            const payload={
            "user_id": userData.id || 0,
            "shift": filters?.shift,
            "start_date": filters?.customDate?.startDate,
            "end_date": filters?.customDate?.endDate,
            "daily": filters?.date,
            "weekly": filters?.week,
            "month": filters?.month,
            "factory_id": userData.factory.id || 0 ,
            "area": userData.area_ids.name || "",
            "subarea": ""
            }
            const res = await AreaService.getSupervisorDetails(payload)
            console.log(res)
            if(res.status==200){
                setAllSupervisors(res.data.supervisorData)
                setloading(false)
            }
        } catch (error) {
            errorToast('Error while fetching data')
            console.log(error)
        }
    }

useEffect(() => {
    if (filters) {
        getSupervisorDetial()
    }
}, [filters])

  return (
   <Container fluid={true}>
    <br />
    {/* <div className='d-flex justify-content-between align-items-center'>
        <h4 className='mb-0'>Supervisors</h4> 
    </div>    */}
    {/* {loading ? <Loader1 /> : <>
    </>} */}
        <SupervisorCardForArea loading={loading} setfilters={setfilters} data={AllSupervisors} />
   </Container>
  )
}
